let klaviyoPublicApiKey = null;
let klaviyoFormInstances = {};

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", initializeKlaviyoBackInStock);

function initializeKlaviyoBackInStock() {
  // Get public API key
  klaviyoPublicApiKey = getKlaviyoPublicApiKey();

  if (!klaviyoPublicApiKey) {
    console.warn("Klaviyo Public API Key nicht gefunden");
    return;
  }

  // Initialize all forms
  initializeAllForms();

  autoSelectAvailableVariants();

  // Set up event listeners
  setupAllEventListeners();

  // Check initial visibility state
  checkInitialFormVisibility();
}

function autoSelectAvailableVariants() {
  // Find all bundle items (excluding optional item)
  const bundleItems = document.querySelectorAll(
    ".bundle-item-container:not(#optional-bundle-item)"
  );

  bundleItems.forEach((bundleItem) => {
    const sizeSelector = bundleItem.querySelector(".size-option-selecter");
    if (!sizeSelector) return;

    const selectedOption = sizeSelector.querySelector("[selected]");

    // Check if the selected option is out of stock
    if (selectedOption && selectedOption.dataset.available !== "true") {
      // Find the first available variant
      const availableOption = sizeSelector.querySelector(
        '.bundle-size-selector[data-available="true"]:not([disabled])'
      );

      if (availableOption) {
        // Remove selected attribute from current selection
        selectedOption.removeAttribute("selected");

        // Add selected attribute to available option
        availableOption.setAttribute("selected", "");

        // Trigger click to update the UI
        availableOption.click();

        // Trigger change event to update bundle prices
        try {
          const sizeSelector = bundleItem.querySelector('.size-option-selecter');
          if (sizeSelector && sizeSelector.dispatchEvent) {
            sizeSelector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } catch (error) {
          console.warn('Failed to trigger bundle price update on auto-select:', error);
          // Graceful degradation - user can manually re-select if needed
        }
      }
    }
  });
}

function getKlaviyoPublicApiKey() {
  // Simply return the API key - no need for complex lookups
  return "XqCGGZ";
}

function initializeAllForms() {
  const formElements = document.querySelectorAll(".klaviyo-back-in-stock-form");

  formElements.forEach((formElement) => {
    const formConfig = getFormConfigurationFromElement(formElement);

    if (formConfig) {
      klaviyoFormInstances[formConfig.formId] = {
        formElement: formElement,
        configuration: formConfig,
        containerElement: formElement.closest(".klaviyo-notify-container"),
      };
    }
  });
}

function getFormConfigurationFromElement(formElement) {
  const configElement = formElement.querySelector(".klaviyo-form-config");
  if (!configElement) return null;

  return {
    formId: formElement.id,
    productId: configElement.dataset.productId,
    variantId: configElement.dataset.variantId,
    productTitle: configElement.dataset.productTitle,
    variantTitle: configElement.dataset.variantTitle,
    productUrl: configElement.dataset.productUrl,
    isBundleItem: configElement.dataset.bundleItem === "true",
  };
}

function setupAllEventListeners() {
  // Handle form submissions
  document.addEventListener("click", handleClickEvents);

  // Handle bundle variant changes (size selection)
  document.addEventListener("click", handleBundleVariantSelection);

  // Handle optional checkbox toggle
  const optionalCheckbox = document.getElementById("nn-spann-toggle");
  if (optionalCheckbox) {
    optionalCheckbox.addEventListener("change", handleOptionalCheckboxChange);
  }
}

function handleOptionalCheckboxChange(event) {
  const isChecked = event.target.checked;
  const optionalBundleItem = document.getElementById("optional-bundle-item");

  if (!optionalBundleItem) return;

  if (isChecked) {
    // The existing bundle script already handles showing the item via .active class
    // We just need to check if we should show the back-in-stock form

    // Small delay to ensure the bundle script has updated the DOM
    setTimeout(() => {
      const selectedOption = optionalBundleItem.querySelector(
        ".bundle-size-selector[selected]"
      );

      if (selectedOption) {
        updateBundleItemFormVisibility(selectedOption);
      }
    }, 100);
  } else {
    // The existing bundle script already handles hiding the item
    // We just need to hide the back-in-stock form
    const notifyContainer =
      findNotifyContainerForBundleItem(optionalBundleItem);
    if (notifyContainer) {
      notifyContainer.style.display = "none";
    }
  }
}

function findNotifyContainerForBundleItem(bundleItem) {
  const mainWrapper =
    bundleItem.closest(".complementary-products-wrapper") ||
    bundleItem.closest(".productView-moreItem");

  if (!mainWrapper) return null;

  let currentElement = bundleItem;
  while (currentElement.nextElementSibling) {
    currentElement = currentElement.nextElementSibling;
    const notifyContainer = currentElement.querySelector(
      ".klaviyo-notify-container"
    );
    if (notifyContainer) return notifyContainer;
  }

  return null;
}

function handleClickEvents(clickEvent) {
  if (clickEvent.target.matches(".klaviyo-notify-submit-button")) {
    clickEvent.preventDefault();
    handleFormSubmission(clickEvent.target);
  }
}

function handleBundleVariantSelection(clickEvent) {
  if (
    clickEvent.target.matches(".bundle-size-selector, .bundle-color-selector")
  ) {
    setTimeout(() => updateBundleItemFormVisibility(clickEvent.target), 100);
  }
}

async function handleFormSubmission(submitButton) {
  const formElement = submitButton.closest(".klaviyo-back-in-stock-form");
  const formInstance = findFormInstanceByElement(formElement);

  if (!formInstance) {
    console.error("Form-Konfiguration nicht gefunden");
    return;
  }

  const emailInput = formElement.querySelector(".klaviyo-email-input");
  const messageContainer = formElement.querySelector(
    ".klaviyo-message-container"
  );

  if (!emailInput || !isValidEmailAddress(emailInput.value)) {
    showUserMessage(
      messageContainer,
      "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      "error"
    );
    return;
  }

  // Show loading state
  const originalButtonText = submitButton.textContent;
  submitButton.disabled = true;
  submitButton.textContent = "Wird gesendet...";

  try {
    // Get current variant data from form config
    const currentVariantData = getCurrentVariantDataFromForm(formElement);

    const subscriptionSuccessful = await subscribeToBackInStock({
      emailAddress: emailInput.value,
      variantId:
        currentVariantData.variantId || formInstance.configuration.variantId,
    });

    console.log("Subscription response:", subscriptionSuccessful);

    if (subscriptionSuccessful) {
      // Get success text from a data attribute or global variable set by Liquid
      const successText =
        getBackInStockSuccessText() ||
        "Vielen Dank! Wir benachrichtigen dich, sobald dieser Artikel wieder verfügbar ist.";

      showUserMessage(messageContainer, successText, "success");
    } else {
      showUserMessage(
        messageContainer,
        "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
        "error"
      );
    }
  } catch (subscriptionError) {
    console.error("Klaviyo Abonnement-Fehler:", subscriptionError);
    showUserMessage(
      messageContainer,
      "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "error"
    );
  } finally {
    submitButton.disabled = false;
    submitButton.textContent = originalButtonText;
  }
}

function getCurrentVariantDataFromForm(formElement) {
  const configElement = formElement.querySelector(".klaviyo-form-config");

  return {
    variantId:
      configElement?.dataset.currentVariantId ||
      configElement?.dataset.variantId,
    productTitle: configElement?.dataset.productTitle,
    variantTitle: configElement?.dataset.variantTitle,
  };
}

async function subscribeToBackInStock({ emailAddress, variantId }) {
  try {
    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoPublicApiKey}`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2024-02-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: ["EMAIL"],
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: emailAddress,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        }),
      }
    );

    if (response.ok) {
      console.log("Klaviyo subscription successful");
      return true;
    } else {
      const errorText = await response.text();
      console.error("Klaviyo API Error:", response.status, errorText);
      return false;
    }
  } catch (error) {
    console.error("Network Error:", error);
    return false;
  }
}

function updateBundleItemFormVisibility(selectedOption) {
  // Find a more stable parent container that contains both the bundle item and the form
  const bundleItemContainer = selectedOption.closest(".bundle-item-container");
  if (!bundleItemContainer) return;

  // Look for the parent that contains both the bundle item and the notify form
  // This could be the complementary-products-wrapper or a parent div
  const mainWrapper =
    bundleItemContainer.closest(".complementary-products-wrapper") ||
    bundleItemContainer.closest(".productView-moreItem");

  if (!mainWrapper) return;

  // Get the item index to match the specific form for this bundle item
  const itemIndex =
    selectedOption.closest("[data-item-index]")?.dataset.itemIndex;

  let notifyContainer = null;

  if (itemIndex) {
    // Look for the notify container that corresponds to this specific item
    // We can use the product ID from the form config to match
    const variantId = selectedOption.dataset.variantId;
    const allNotifyContainers = mainWrapper.querySelectorAll(
      ".klaviyo-notify-container"
    );

    allNotifyContainers.forEach((container) => {
      const configElement = container.querySelector(".klaviyo-form-config");
      if (configElement && configElement.dataset.variantId === variantId) {
        notifyContainer = container;
      }
    });
  }

  // Fallback: find the closest notify container after this bundle item
  if (!notifyContainer) {
    let currentElement = bundleItemContainer;
    while (currentElement.nextElementSibling) {
      currentElement = currentElement.nextElementSibling;
      notifyContainer = currentElement.querySelector(
        ".klaviyo-notify-container"
      );
      if (notifyContainer) break;
    }
  }

  if (!notifyContainer) {
    console.log("No notify container found");
    return;
  }

  // Get variant data from the selected option
  const isVariantAvailable = selectedOption.dataset.available === "true";
  const selectedVariantId = selectedOption.dataset.variantId;

  // For optional item, also check if checkbox is checked
  const isOptionalItem = bundleItemContainer.id === "optional-bundle-item";
  const optionalCheckbox = document.getElementById("nn-spann-toggle");
  const isOptionalChecked = optionalCheckbox ? optionalCheckbox.checked : false;

  if (!isVariantAvailable && selectedVariantId) {
    // Only show form if not optional OR if optional is checked
    if (!isOptionalItem || isOptionalChecked) {
      const formElement = notifyContainer.querySelector(
        ".klaviyo-back-in-stock-form"
      );
      if (formElement) {
        updateFormVariantConfiguration(formElement, {
          variantId: selectedVariantId,
          variantTitle: selectedOption.dataset.optionValue || "",
        });
      }
      notifyContainer.style.display = "block";
    }
  } else {
    notifyContainer.style.display = "none";
  }
}

function updateFormVariantConfiguration(formElement, variantConfiguration) {
  const configElement = formElement.querySelector(".klaviyo-form-config");
  if (configElement) {
    if (variantConfiguration.variantId) {
      configElement.dataset.currentVariantId = variantConfiguration.variantId;
    }
    if (variantConfiguration.variantTitle) {
      configElement.dataset.variantTitle = variantConfiguration.variantTitle;
    }
  }
}

function findFormInstanceByElement(formElement) {
  return Object.values(klaviyoFormInstances).find(
    (instance) => instance.formElement === formElement
  );
}

function showUserMessage(messageContainer, messageText, messageType) {
  if (!messageContainer) return;

  // Clear any existing messages
  messageContainer.innerHTML = "";

  // Create message element
  const messageElement = document.createElement("div");
  messageElement.className = `klaviyo-message klaviyo-message--${messageType}`;
  messageElement.textContent = messageText;

  // Add some inline styles to ensure visibility
  messageElement.style.cssText = `
    display: block !important;
    padding: 10px;
    margin: 10px 0;
    border-radius: 4px;
    ${
      messageType === "success"
        ? "background-color: #d4edda; color: #155724; border: 1px solid #c3e6cb;"
        : "background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb;"
    }
  `;

  messageContainer.appendChild(messageElement);
  messageContainer.style.display = "block";
  messageContainer.style.visibility = "visible";

  console.log("Success message shown:", messageElement);

  // Hide success messages after 5 seconds
  if (messageType === "success") {
    setTimeout(() => {
      messageContainer.style.display = "none";
    }, 15000);
  }
}

function checkInitialFormVisibility() {
  // Check all bundle items on page load
  const allBundleItems = document.querySelectorAll(".bundle-item-container");

  allBundleItems.forEach((bundleItem) => {
    // Handle the optional bundle item (third component) differently
    if (bundleItem.id === "optional-bundle-item") {
      // For the optional item, check all visible variant options
      const visibleOptions = bundleItem.querySelectorAll(
        ".bundle-size-selector[style*='block'], .bundle-size-selector:not([style*='none'])"
      );

      // Check if any visible variant is out of stock
      visibleOptions.forEach((option) => {
        const isVariantAvailable = option.dataset.available === "true";
        if (!isVariantAvailable) {
          updateBundleItemFormVisibility(option);
        }
      });
    } else {
      // For regular bundle items (first two), use the existing logic
      const selectedOption = bundleItem.querySelector(
        ".bundle-size-selector[selected], .product-form__label[selected]"
      );

      if (selectedOption) {
        const isVariantAvailable = selectedOption.dataset.available === "true";
        if (!isVariantAvailable) {
          updateBundleItemFormVisibility(selectedOption);
        }
      }
    }
  });
}

function isValidEmailAddress(emailAddress) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress);
}

// Export for potential external use
window.klaviyoBackInStockManager = {
  updateBundleItemFormVisibility,
};
